/**
 * The programme FAQs.
 *
 * Static copy, in the flow rather than in a view, because THREE surfaces show it: the customer
 * summary's Loyalty tab, "View program details" on the consent block, and the standalone
 * programme screen. It lived in
 * `LoyaltyLeg/PointsBaseRewardScreen/staticData.ts` (deleted 2026-09-09) and was imported by
 * two of those directly.
 *
 * ⚠️ **Carried over VERBATIM, and the first entry names one merchant's programme by name.** That
 * is wrong for every other merchant, and it is not fixed here: changing customer-facing copy is
 * a product decision with its own review, not part of moving a file. It is flagged so the next
 * person to touch this does not assume it was considered and kept.
 *
 * A merchant-specific or API-served FAQ list would replace this array; nothing else changes,
 * because every consumer reads it from here.
 */
export interface ProgramFaq {
  question: string;
  answer: string;
}

export const PROGRAM_FAQS: ProgramFaq[] = [
 {
    question: "How do I join the loyalty program?",
    answer:
      "You can enroll in the loyalty program by enabling the enroll toggle on the POS interface at the time of customer addition.",
  },
  {
    question: "Can I earn bonus points on my orders?",
    answer:
      "Yes. Bonus points can be earned on eligible orders when they are active.",
  },
];
